import React, { useState } from "react";
import CardStory from "./CardStory";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 120,
    },
  },
};

const LevelRead = ({ item }) => {
  const [seeMore, setSeeMore] = useState(false);

  return (
    <motion.div
      className="LevelRead"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <h1 className="level-title-bold">
        Level <span className="level-red">{item._id}</span>
      </h1>
      <div className="level">
        <div className="row cards">
          {seeMore
            ? item.reads.map((read, index) => (
                <CardStory read={read} key={index} />
              ))
            : item.reads
                .sort(() => Math.random() - Math.random())
                .slice(0, 4)
                .map((read, index) => <CardStory read={read} key={index} />)}
        </div>
        <div className="level-more-btn">
          <motion.button
            className="contBut-med-width"
            whileHover={{ scale: 1.03 }}
            onClick={() => setSeeMore(!seeMore)}
          >
            {seeMore ? "Less" : "More"}
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default LevelRead;
